import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface InformationBoxProps {
  title: string;
  children: React.ReactNode;
  onClose?: () => void;
  buttonText?: string;
}

const InformationBox = ({ title, children, onClose, buttonText }: InformationBoxProps) => (
  <Box
    sx={{
      borderRadius: '8px',
      borderColor: '#fff',
      border: 1,
      m: 14,
      maxWidth: 800,
      mx: 'auto',
    }}
  >
    <DialogTitle>
      <Box sx={{
        textAlign: 'center',
      }}
      >
        <Typography variant="h4" color="secondary">
          { title }
        </Typography>
      </Box>
    </DialogTitle>

    <DialogContent>
      {children}
    </DialogContent>

    {buttonText && onClose && (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          width: '100%',
          p: 5,
        }}
      >
        <Button color="secondary" onClick={onClose}>
          {buttonText}
        </Button>
      </Box>
    )}
  </Box>
);

export default InformationBox;
